import * as React from 'react';

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgEyeTestAlt = function SvgEyeTestAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-hidden": "true",
    className: "eye-test-alt_svg__icon eye-test-alt_svg__icon--eye-test-alt"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 4.5c4.344-.066 8.699 2.934 11.379 5.88l.002.003a2.413 2.413 0 0 1 0 3.23l-.002.002C20.76 16.497 16.416 19.566 12 19.498c-4.416.068-8.76-3-11.376-5.883l-.002-.002a2.413 2.413 0 0 1 0-3.23l.002-.002C3.3 7.434 7.656 4.434 12 4.5ZM1.735 11.389a.913.913 0 0 0 0 1.22c2.509 2.763 6.474 5.454 10.252 5.39h.026c3.778.064 7.744-2.627 10.255-5.39a.913.913 0 0 0 0-1.22c-2.566-2.82-6.543-5.45-10.255-5.387h-.026c-3.712-.063-7.69 2.567-10.252 5.387Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.149 9.227a3 3 0 1 0-2.296 5.542 3 3 0 0 0 2.296-5.542ZM12 7.5A4.499 4.499 0 0 1 16.5 12M12 7.5A4.5 4.5 0 1 0 16.5 12",
    clipRule: "evenodd"
  })));
};

export { SvgEyeTestAlt as default };
//# sourceMappingURL=eye-test-alt.svg.js.map
